document.documentElement.classList.remove('no-js');

const $ = (selector, scope = document) => scope.querySelector(selector);
const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const lockPage = (locked) => document.body.classList.toggle('is-locked', locked);

function announce(message) {
  const region = $('[data-live-region]');
  if (region) region.textContent = message;
}

function openLayer(target) {
  if (!target) return;
  target.hidden = false;
  requestAnimationFrame(() => target.classList.add('is-open'));
  lockPage(true);
  const overlay = $('[data-site-overlay]');
  if (overlay && !target.classList.contains('site-dialog')) overlay.hidden = false;
  const focusable = $('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', target);
  if (focusable) focusable.focus();
}

function closeLayer(target) {
  if (!target) return;
  target.classList.remove('is-open');
  window.setTimeout(() => { target.hidden = true; }, 260);
  lockPage(false);
  const overlay = $('[data-site-overlay]');
  if (overlay) overlay.hidden = true;
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-open]');
  if (opener) {
    event.preventDefault();
    openLayer(document.getElementById(opener.dataset.open));
    return;
  }
  const closer = event.target.closest('[data-close]');
  if (closer) {
    event.preventDefault();
    closeLayer(closer.closest('.mobile-drawer, .site-dialog, .cart-drawer'));
    return;
  }
  if (event.target.matches('[data-site-overlay]')) {
    $$('.mobile-drawer.is-open, .cart-drawer.is-open').forEach(closeLayer);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    $$('.mobile-drawer.is-open, .site-dialog.is-open, .cart-drawer.is-open').forEach(closeLayer);
  }
});

document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-media-target]');
  if (!thumb) return;
  const gallery = thumb.closest('[data-product-gallery]');
  if (!gallery) return;
  $$('.product-gallery__thumb', gallery).forEach((item) => item.classList.remove('is-active'));
  $$('.product-gallery__image', gallery).forEach((item) => item.classList.remove('is-active'));
  thumb.classList.add('is-active');
  const image = document.getElementById(thumb.dataset.mediaTarget);
  if (image) image.classList.add('is-active');
});

function formatMoney(cents, format = '₹{{amount}}') {
  const amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const noDecimals = Math.round(cents / 100).toLocaleString('en-IN');
  return format
    .replace(/{{\s*amount_no_decimals\s*}}/g, noDecimals)
    .replace(/{{\s*amount\s*}}/g, amount);
}

function initProductForm(form) {
  const root = form.closest('[data-product-root]');
  if (!root) return;
  const variantsNode = $('[data-product-variants]', root);
  if (!variantsNode) return;
  const variants = JSON.parse(variantsNode.textContent);
  const idInput = $('[name="id"]', form);
  const addButton = $('[data-add-to-cart]', form);
  const price = $('[data-product-price]', root);
  const compare = $('[data-product-compare]', root);
  const moneyFormat = root.dataset.moneyFormat || '₹{{amount}}';

  const update = () => {
    const selected = $$('[data-option-position]', form).map((group) => {
      const checked = $('input:checked', group);
      return checked ? checked.value : '';
    });
    const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
    if (!variant) {
      idInput.value = '';
      addButton.disabled = true;
      addButton.textContent = 'Unavailable';
      return;
    }
    idInput.value = variant.id;
    price.textContent = formatMoney(variant.price, moneyFormat);
    if (compare) {
      compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, moneyFormat) : '';
      compare.hidden = !(variant.compare_at_price > variant.price);
    }
    addButton.disabled = !variant.available;
    addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };

  form.addEventListener('change', update);
  update();
}

$$('[data-product-form]').forEach(initProductForm);

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form || document.body.dataset.designMode === 'true') return;
  const drawer = $('#CartDrawer');
  if (!drawer || drawer.dataset.cartMode !== 'drawer') return;
  event.preventDefault();
  const button = $('[data-add-to-cart]', form);
  const original = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const response = await fetch(window.sanskartistRoutes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add this item.');
    const sectionResponse = await fetch(`${window.sanskartistRoutes.root}?sections=cart-drawer`);
    const sections = await sectionResponse.json();
    const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = $('#shopify-section-cart-drawer', html);
    const current = $('#shopify-section-cart-drawer');
    if (fresh && current) current.replaceWith(fresh);
    const updatedDrawer = $('#CartDrawer');
    openLayer(updatedDrawer);
    const cartResponse = await fetch(window.sanskartistRoutes.cart + '.js');
    const cartState = await cartResponse.json();
    $$('[data-cart-count]').forEach((count) => { count.textContent = cartState.item_count; });
    announce('Item added to your bag.');
  } catch (error) {
    announce(error.message);
    button.textContent = 'Try again';
  } finally {
    button.disabled = false;
    window.setTimeout(() => { button.textContent = original; }, 1200);
  }
});

let predictiveTimer;
document.addEventListener('input', (event) => {
  const input = event.target.closest('[data-predictive-input]');
  if (!input) return;
  const results = $('[data-predictive-results]', input.closest('form'));
  window.clearTimeout(predictiveTimer);
  const query = input.value.trim();
  if (query.length < 2) {
    if (results) results.innerHTML = '';
    return;
  }
  predictiveTimer = window.setTimeout(async () => {
    try {
      const url = `${window.sanskartistRoutes.predictiveSearch}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&section_id=predictive-search`;
      const response = await fetch(url);
      const markup = await response.text();
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const fresh = $('[data-predictive-content]', doc);
      if (results && fresh) results.innerHTML = fresh.innerHTML;
    } catch (_error) {
      if (results) results.innerHTML = '';
    }
  }, 220);
});

document.addEventListener('change', (event) => {
  const control = event.target.closest('[data-auto-submit]');
  if (control && control.form) control.form.submit();
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-scroll-product-form]');
  if (!trigger) return;
  const form = $('[data-product-root] [data-product-form]');
  if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

document.addEventListener('click', (event) => {
  const dot = event.target.closest('[data-lux-hero-dot]');
  if (!dot) return;
  const hero = dot.closest('[data-lux-hero]');
  if (!hero) return;
  hero.style.setProperty('--lux-slide', dot.dataset.luxHeroDot);
  $$('[data-lux-hero-dot]', hero).forEach((item) => {
    const active = item === dot;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-current', active ? 'true' : 'false');
  });
});

$$('[data-recommendations-url]').forEach(async (section) => {
  try {
    const response = await fetch(section.dataset.recommendationsUrl);
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const fresh = $('[data-recommendations-url]', doc);
    if (fresh && fresh.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
  } catch (_error) {
    // Recommendations are optional and should never block the product page.
  }
});

document.addEventListener('shopify:section:load', (event) => {
  $$('[data-product-form]', event.target).forEach(initProductForm);
});
